import { useState } from "react";

import { EMAIL } from "config/tags";
import t, { AsHtml } from "utils/translate";
import { sendDataToGpcByResults } from "utils/gpc";

import Textfield from "components/Profile/Textfield";
import SiteWrapper from "components/SiteWrapper";
import ContentGutter from "components/ContentGutter";
import RoundButton from "components/RoundButton";

import styles from "./styles.module.scss";

export interface ResultsEmailProps {
  onComplete: () => void;
  resultsScreen: string;
}

const isValidRegex = (value, regex) => {
  const pattern = new RegExp(regex);
  return pattern.test(value);
};

export const ResultsEmail: React.FC<ResultsEmailProps> = ({ onComplete, resultsScreen }) => {
  const [email, setEmail] = useState<string>("");
  const [open, setOpen] = useState<boolean>(true);
  const [isDisabled, setDisabled] = useState(true);
  const rules = window.ww.validations;

  const handleEmailChange = (key, value) => {
    if (!value) {
      setDisabled(true);
      return;
    }

    setEmail(value);
    setDisabled(false);
  };

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData(e.target as HTMLFormElement);
    const formProps = Object.fromEntries(formData);

    if (!formProps[EMAIL] || isDisabled) {
      return;
    }

    await sendDataToGpcByResults({
      email,
      resultsScreen
    });

    onComplete();
    setOpen(false);
  };

  if (!open) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <SiteWrapper size="small">
          <ContentGutter>
            <div className={styles.inner}>
              <div className={styles.header}>
                <AsHtml value={t("EMAIL_CAPTURE_MODAL_HEADLINE")} />
              </div>
              <div className={styles.description}>
                <AsHtml value={t("EMAIL_CAPTURE_MODAL_DESCRIPTION")} />
              </div>
              <div className={styles.input}>
                <form className={styles.profile} onSubmit={handleFormSubmit}>
                  <Textfield
                    id={EMAIL}
                    name={EMAIL}
                    placeholder={t("EMAIL_PLACEHOLDER")}
                    value={email}
                    onChange={handleEmailChange}
                    rules={{
                      errorMessages: {
                        isRequired: t("FIELD_ERROR_REQUIRED"),
                        isMoreThanMax: t("EMAIL_ERROR_TOO_LONG"),
                        isInvalidPattern: t("EMAIL_ERROR_INVALID")
                      },
                      validators: {
                        isRequired: value => String(value).length === 0,
                        isMoreThanMax: value =>
                          rules.email.max <= String(value).length,
                        isInvalidPattern: value =>
                          !isValidRegex(value, rules.email.regex)
                      }
                    }}
                    styles={styles}
                  />
                  <RoundButton
                    onClick={() => {}}
                    isDisabled={isDisabled}
                    type="submit"
                    className={styles.button}
                  >
                    {t("NEXT")}
                  </RoundButton>
                </form>
              </div>
              <div className={styles.disclaimer}>
                <AsHtml value={t("EMAIL_CAPTURE_MODAL_DISCLAIMER")} />
              </div>
            </div>
          </ContentGutter>
        </SiteWrapper>
      </div>
    </div>
  );
};
